import { render, staticRenderFns } from "./DevComponentMarkupTable.vue?vue&type=template&id=7515bfa0"
import script from "./DevComponentMarkupTable.vue?vue&type=script&lang=js"
export * from "./DevComponentMarkupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports